import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

function CursorGrowIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="26"
      height="14"
      viewBox="0 0 24 14"
      fill="black"
      stroke="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.5 5.5L6.49737 5.51844V2L1 6.9999L6.5 12L6.49737 8.5L19.5 8.5V12L25 6.9999L19.5 2V5.5Z" />
    </svg>
  );
}

const NumberFieldScrubAreaCursor = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithRef<typeof BaseNumberField.ScrubAreaCursor>
>((props, forwardedRef) => {
  const { children, ...cursorProps } = props;
  return (
    <BaseNumberField.ScrubAreaCursor {...cursorProps} ref={forwardedRef}>
      {children ?? <CursorGrowIcon />}
    </BaseNumberField.ScrubAreaCursor>
  );
});

NumberFieldScrubAreaCursor.displayName = "NumberField.ScrubAreaCursor";

export default NumberFieldScrubAreaCursor;
